import { createRoot } from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { App as NativeApp } from '@capacitor/app';
import App from './App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(<App />);

if (Capacitor.isNativePlatform()) {
  NativeApp.addListener('backButton', () => {
    const event = new Event('kapitalia:back', { cancelable: true });
    if (window.dispatchEvent(event)) NativeApp.exitApp();
  });
}

if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'));
}
